import React from 'react';
import Loadable from 'react-loadable';
import LoadableLoading from 'components/LoadableLoading';
import { getWorkTypeAvailableColumns } from './api';

export const path = '/work-type/list';

const PageWorkTypeList: React.FC = (props) => {
  const WorkTypeList = Loadable.Map({
    loader: {
      page: () => import('./page'),
      columns: getWorkTypeAvailableColumns,
    },
    loading: LoadableLoading,
    render(loaded, loadedProps: {}) {
      const Page = loaded.page.default;

      return <Page {...loadedProps} {...loaded} />;
    },
  });

  return <WorkTypeList {...props} />;
};

export default PageWorkTypeList;
